const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./product/details'));
    processInclude(require('sunnie_foods/product/wishlist'));

    $(document).ready(function() {
        $('#goToNutritionalInfo').on('click', function(event) {
            event.preventDefault();
            var $targetElement = $('[id^="product-info-container"]');

            if ($targetElement.length > 0) {
                var targetOffset = $targetElement.first().offset().top - 150;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            } else {
                console.error('ID not found');
            }
        });
    });
    
});